export default __webpack_public_path__ + "static/tinHero-36ddc1611cd165e12f252364841adc7e.jpg";